import React, { Component } from "react";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import AppRoute from "./Route";
import App from "../App";
// import AuthService from '../services/AuthService';
import { actions } from "../redux/actions";
import {
  Index,
  AddUser,
  Forget,
  ForgetReset,
  Dashboard,
  Users,
  EditUser,
  AvaliacaoGenetica,
  SubModulos,
  UsuarioConfirmacao,
  GraficoEvolucaoGenetica,
  EficienciaReprodutiva,
} from "./Pages";
import { stat } from "fs";

export class Routes extends Component {
  render() {
    // can pass in redux props this way so child components dont have to be connected

    // eslint-disable-next-line
    const state = { ...this.props };

    return (
      <Router>
        <App>
          <Switch>
            {/* Public Routes */}

            <AppRoute public exact path="/" {...this.props} component={Index} />

            {/* <AppRoute
              public
              exact
              path="/dashboard"
              {...this.props}
              component={Dashboard}
              // title="Dashboard"
            /> */}
            <AppRoute
              public
              exact
              path="/login"
              {...this.props}
              component={Index}
              // title="Login"
            />
            <AppRoute
              public
              exact
              path="/cadastro"
              {...this.props}
              component={AddUser}
              // title="Cadastro"
            />
            <AppRoute
              public
              exact
              path="/recuperar-senha"
              {...this.props}
              component={Forget}
              // title="Recuperar senha"
            />
            <AppRoute
              public
              exact
              path="/nova-senha"
              {...this.props}
              component={ForgetReset}
              // title="Nova senha"
            />

            {/* Private Routes */}
            <AppRoute
              private
              exact
              state={state}
              path="/dashboard"
              {...this.props}
              component={Dashboard}
              title="Dashboard"
            />

            <AppRoute
              private
              exact
              state={state}
              path="/usuarios"
              {...this.props}
              component={Users}
              // title="Usuários"
            />

            <AppRoute
              private
              state={state}
              path="/editar-usuario/:id"
              {...this.props}
              component={EditUser}
              // title="Editar usuário"
            />

            <AppRoute
              private
              state={state}
              path="/usuario-confirmacao/:token/:email/:modulo/:lastAccess"
              {...this.props}
              component={UsuarioConfirmacao}
              // title="Editar usuário"
            />

            <AppRoute
              private
              state={state}
              path="/submodulos/:id"
              {...this.props}
              component={SubModulos}
              // title="SubModulos"
            />

            {/* Public Search Routes */}

            <AppRoute
              isPublicSearch
              state={state}
              path="/avaliacao-genetica/eficiencia-reprodutiva/:id"
              {...this.props}
              component={EficienciaReprodutiva}
              // title="Consulta de Eficiência Reprodutiva"
            />

            <AppRoute
              isPublicSearch
              state={state}
              path="/avaliacao-genetica/:tipo/:id"
              {...this.props}
              component={AvaliacaoGenetica}
              // title="Consulta de Avaliação Genética"
            />

            {/* Rotas com as URLs cadastradas hoje em ancpnet2_submodulos (ex: /consulta-avaliacao-genetica/1),
                que nao seguem o padrao antigo /avaliacao-genetica/:tipo/:id. O componente nao usa os
                parametros da URL, entao e seguro reaproveitar o mesmo AvaliacaoGenetica aqui. */}
            <AppRoute
              isPublicSearch
              state={state}
              path="/consulta-avaliacao-genetica/:id"
              {...this.props}
              component={AvaliacaoGenetica}
              // title="Consulta de Avaliação Genética"
            />

            <AppRoute
              isPublicSearch
              state={state}
              path="/evolucao-genetica/:id"
              {...this.props}
              component={AvaliacaoGenetica}
              // title="Evolução Genética"
            />

            <AppRoute
              isPublicSearch
              state={state}
              path="/grafico-evolucao-genetica"
              {...this.props}
              component={GraficoEvolucaoGenetica}
              // title="Consulta de Avaliação Genética"
            />

          </Switch>
        </App>
      </Router>
    );
  }
}

Routes.propTypes = {
  logout: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  token: PropTypes.string,
};

const mapStateToProps = (state) => {
  const { isAuthenticated, token, user } = state;
  return {
    isAuthenticated,
    token,
    user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Routes);
